<header class="header-area p-relative">
    <div
        [class.dark-navbar-area]="themeService.isDark()"
        [ngClass]="{'sticky': isSticky}"
        class="navbar-area navbar-style-three"
    >
        <div class="container">
            <nav [class.active]="classApplied" class="navbar navbar-expand-lg navbar-light bg-light">
                <a
                    [class.d-none]="themeService.isDark()"
                    class="navbar-brand"
                    routerLink="/"
                >
                    <img alt="Rooftop Logo" height="54"
                         ngSrc="cms/rooftop_logo_1ab581168f.webp" priority width="200">
                </a>
                <a [class.d-block]="themeService.isDark()" class="navbar-brand d-none" routerLink="/">
                    <img alt="Rooftop Logo Dark" height="54"
                         ngSrc="cms/rooftop_logo_1ab581168f.webp" priority
                         width="200">
                </a>
                <button (click)="toggleClass()" class="navbar-toggler" title="Menu" type="button">
          <span class="burger-menu">
            <span class="top-bar"></span>
            <span class="middle-bar"></span>
            <span class="bottom-bar"></span>
          </span>
                </button>
                <div class="collapse navbar-collapse justify-content-center" id="navbarSupportedContent">
                    <ul (click)="onNavClick($event)" class="navbar-nav">
                        <li class="nav-item">
                            <a (click)="closeMenu()"
                               [routerLinkActiveOptions]="{exact: true}"
                               [routerLink]="['/activities']"
                               class="nav-link"
                               routerLinkActive="active">Activities</a>
                        </li>
                        <li class="nav-item">
                            <a (click)="closeMenu()"
                               [routerLinkActiveOptions]="{exact: true}"
                               [routerLink]="['/artworks']"
                               class="nav-link"
                               routerLinkActive="active">Artworks</a>
                        </li>
                        <li class="nav-item">
                            <a (click)="closeMenu()"
                               [routerLinkActiveOptions]="{exact: true}"
                               [routerLink]="['/courses']"
                               class="nav-link"
                               routerLinkActive="active">Courses</a>
                        </li>
                        <li class="nav-item">
                            <a (click)="closeMenu()"
                               [routerLinkActiveOptions]="{exact: true}"
                               [routerLink]="['/shop']"
                               class="nav-link"
                               routerLinkActive="active">Shop <i class='bx bx-chevron-down'></i></a>
                            <ul class="dropdown-menu">
                                <li *ngFor="let category of shopCategories()" class="nav-item">
                                    <a (click)="closeMenu()"
                                       [routerLinkActiveOptions]="{exact: true}"
                                       [routerLink]="['/shop', category.slug]"
                                       class="nav-link"
                                       routerLinkActive="active">{{ category.name }}</a>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item">
                            <a (click)="closeMenu()"
                               [routerLinkActiveOptions]="{exact: true}"
                               [routerLink]="['/art-wiki']"
                               class="nav-link"
                               routerLinkActive="active">Art Wiki</a>
                        </li>
                        <li class="nav-item">
                            <a (click)="closeMenu()"
                               [routerLinkActiveOptions]="{exact: true}"
                               [routerLink]="['/blogs']"
                               class="nav-link"
                               routerLinkActive="active">Blog</a>
                        </li>
                    </ul>
                </div>
                <div class="others-option">
                    <ng-container *ngIf="isLoading(); else content">
                        <i class="bx bx-loader-alt spinner-icon"></i>
                    </ng-container>
                    <ng-template #content>
                        <a
                            (click)="openLoginModal()"
                            *ngIf="!isLoggedIn()"
                            class="cart-wrapper-btn d-inline-block"
                            title="Login"
                        >
                            <i class='bi bi-person-up'></i>
                        </a>
                        <a
                            *ngIf="isLoggedIn()"
                            [routerLink]="['/profile']"
                            aria-label="User profile"
                            class="profile-wrapper d-inline-flex align-items-center justify-content-center"
                            title="Profile"
                        >
                            <div class="profile-image-container">
                                <img
                                    *ngIf="profileImageUrl()"
                                    [loaderParams]="{height:30, fit:'inside'}"
                                    [ngSrc]="profileImageUrl()"
                                    alt="Profile Picture"
                                    class="profile-image"
                                    height="30"
                                    width="30"
                                >
                                <i *ngIf="!profileImageUrl()" class='bx bx-user-circle profile-icon'></i>
                            </div>
                        </a>
                    </ng-template>
                    <a (click)="toggleSideCart()" class="cart-wrapper-btn d-inline-block" title="Cart">
                        <i class='bx bx-cart-alt'></i>
                        <span>{{ cartItemCount() }}</span>
                    </a>
                </div>
            </nav>
        </div>
    </div>
</header>

<app-cart-page (toggleSideCart)="toggleSideCart()" [isSideCartOpen]="isSideCartOpen"></app-cart-page>

<div
    [class.active]="classApplied3"
    [class.dark-search-overlay]="themeService.isDark()"
    class="search-overlay"
>
    <div class="d-table">
        <div class="d-table-cell">
            <div class="search-overlay-layer"></div>
            <div class="search-overlay-layer"></div>
            <div class="search-overlay-layer"></div>
            <div (click)="toggleClass3()" class="search-overlay-close">
                <span class="search-overlay-close-line"></span>
                <span class="search-overlay-close-line"></span>
            </div>
            <div class="search-overlay-form">
                <form>
                    <input class="input-search" placeholder="Search here..." type="text">
                    <button type="submit"><i class='bx bx-search-alt'></i></button>
                </form>
            </div>
        </div>
    </div>
</div>
